import { Row, Col, Container, Spinner } from "react-bootstrap";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  boxFetcher,
  campaignFetcher,
  channelFetcher,
  searchFetcher,
  videoFetcher,
} from "../../api/requests";
import { paginate } from "../../api/requests";
import { SearchContext } from "../../context/search";
import { useLocation } from "react-router-dom";
import Paginate from "../Atomics/Paginate/Paginate";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import Cookies from "js-cookie";
import { useSelectedVideos } from "../../context/selectedVideos";
import { baseURL } from "../../api/dataFetcher";

const Videos = ({
  mine,
  tag = false,
  search = false,
  liked = false,
  popular = false,
  saved = false,
  owner = false,
  all = false,
  searchedText,
  tab,
  categoryName = "",
  tagName = "",
  boxId,
  limitedCardNumber,
  allVideos,
  videoType,
  campaignName,
  subCategory = false,
}) => {
  const { id } = useParams();
  const [videos, setVideos] = useState([]);
  const [savedVideos, setSavedVideos] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const { searchedItem } = useContext(SearchContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const adminValue = queryParams.get("admin");
  const [parsedUser, setParsedUser] = useState(null);
  const {
    selectedVideos,
    addVideo,
    updateVideoBoxRelationIds,
    initializeSelectedVideos,
    resetArray,
  } = useSelectedVideos();
  const [showPagination, setShowPagination] = useState(true);
  const [alertText, setAlertText] = useState("");
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const publisherId = new URLSearchParams(location.search).get("publisher");
  const [selectedTabVideos, setSelectedTabVideos] = useState([]);
  const initializedBoxRef = useRef(null);

  // Debounce for search term to reduce API calls
  const debouncedSearchedItem = useDebouncedValue(searchedItem, 300);

  const groupedCampaignVideos = useMemo(() => {
    if (!campaignId || !videos?.length) return null;

    setShowPagination(false);
    return videos.reduce((groups, video) => {
      const campaignName = video.campaign?.name || "کمپین بدون نام";
      if (!groups[campaignName]) {
        groups[campaignName] = [];
      }
      groups[campaignName].push(video);
      return groups;
    }, {});
  }, [campaignId, videos]);

  const handlePageChange = async (arg) => {
    setLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      if (saved) {
        setSavedVideos(res.results);
      } else {
        setVideos(res.results);
      }

      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setVideos([]);
    const getVideos = async () => {
      setLoading(true);

      try {
        let res;

        if (allVideos) {
          res = await videoFetcher.getConfirmedVideos();
        } else {
          if (mine) {
            if (owner) {
              res = await videoFetcher.getUserVideos(parsedUser.user_id);
            } else
              res = !campaignId
                ? await channelFetcher.getChannelsVideos({ id: id })
                : publisherId
                ? await campaignFetcher.getNormalUsersCampaigns(publisherId)
                : await campaignFetcher.getCampaignVideos({ campaignId: id });
          } else if (tag) {
            res = await videoFetcher.videosBaseOnTag(id);
          } else if (subCategory) {
            res = await videoFetcher.videosBaseOnSubCategory(id);
          } else if (search) {
            res = await searchFetcher.get(debouncedSearchedItem);
          } else if (liked) {
            res = await videoFetcher.likedVideos();
          } else if (popular) {
            res = await videoFetcher.popular();
          } else if (saved && parsedUser) {
            res = await videoFetcher.savedVideos(parsedUser.user_id);
            setSavedVideos(res.results);
          } else if (all) {
            if (tab === "ویدئوهای منتخب") {
              setVideos([]);

              // Only fetch if boxId is defined
              if (boxId) {
                try {
                  setLoading(true);
                  const res0 =
                    videoType === "campaign"
                      ? await boxFetcher.getBoxItemByHandForCampaign(boxId)
                      : await boxFetcher.getBoxItemByHand(boxId);

                  res = { results: [] };

                  setSelectedTabVideos(res0?.results);
                  setShowPagination(false);
                } catch (err) {
                  console.error(err);
                } finally {
                  setLoading(false);
                }
              } else {
                res = { results: [] };
                setShowPagination(false);
              }
            } else {
              setVideos([]);
              // Only initialize selected videos once per boxId to avoid duplicate POST requests
              if (boxId && initializedBoxRef.current !== boxId) {
                // Reset selected videos when switching to a new box
                resetArray();

                const previouslyChosen =
                  videoType === "campaign"
                    ? await boxFetcher.getBoxItemByHandForCampaign(boxId)
                    : await boxFetcher.getBoxItemByHand(boxId);

                if (previouslyChosen?.results?.length) {
                  const chosenIds = previouslyChosen.results.map(
                    (item) => item.video?.id
                  );

                  // Initialize selected videos without making POST requests
                  // (these videos are already associated with the box in the backend)
                  initializeSelectedVideos(chosenIds);

                  const chosenVideoAndBoxIds = previouslyChosen.results.map(
                    (item) => ({ videoId: item.video?.id, relationId: item.id })
                  );

                  updateVideoBoxRelationIds(chosenVideoAndBoxIds);
                  initializedBoxRef.current = boxId;
                }
              }
              res =
                videoType === "campaign"
                  ? await campaignFetcher.getCampaignVideos({
                      campaignName: campaignName,
                    })
                  : await videoFetcher.getConfirmedVideos(
                      searchedText,
                      categoryName,
                      tagName
                    );
              setShowPagination(true);
            }
          } else {
            res = await videoFetcher.videosBaseOnCategory(id);
          }
        }

        if (!saved || tab !== "ویدئوهای منتخب") {
          setVideos(res.results);
        }

        if (tab === "ویدئوهای منتخب") {
          setShowPagination(false);
        } else {
          setShowPagination(true);
          setPaginationInfo(res);
          setTotalCount(res.count);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };

    if (saved && parsedUser) {
      getVideos();
    } else if (!saved) {
      getVideos();
    }
  }, [
    location,
    id,
    debouncedSearchedItem,
    saved,
    parsedUser,
    searchedText,
    tab,
  ]);

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      const parsed = JSON.parse(user);
      setParsedUser(parsed);
    }
  }, []);

  // Reset when modal closes (boxId becomes null)
  useEffect(() => {
    if (!boxId && initializedBoxRef.current) {
      initializedBoxRef.current = null;
      resetArray(); // Clear selected videos when modal closes
    }
  }, [boxId, resetArray]);

  useEffect(() => {
    if (selectedVideos.length > limitedCardNumber) {
      setAlertText(
        `شما مجاز به انتخاب حداکثر ${limitedCardNumber} مورد هستید.`
      );
    } else {
      setAlertText("");
    }
  }, [limitedCardNumber, selectedVideos, tab]);

  return (
    <ContentWrapper>
      <Container fluid className="pb-0">
        <div
          className="video-block section-padding"
          style={{ paddingLeft: "30px", paddingRight: "30px" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                style={{ marginBottom: "30px" }}
              />
            </div>
          ) : (
            <>
              {alertText && (
                <Row style={{ color: "red" }} className="mr-1 mb-3">
                  {alertText}
                </Row>
              )}
              <Row style={{ flexDirection: campaignId && "column" }}>
                {saved ? (
                  savedVideos.length > 0 ? (
                    savedVideos.map((item, index) => (
                      <Col xl={2} sm={4} className="mb-3" key={index}>
                        <VideoCard
                          imgSrc={
                            item?.video_post.cover
                              ? item?.video_post.cover
                              : "img/v4.png"
                          }
                          time={item?.video_post.duration}
                          videoTitle={item?.video_post.title}
                          videoCategory={item?.video_post.categorys?.name}
                          views={item?.video_post.counted_views}
                          timeAgo={item?.video_post.published_date}
                          verified
                          mine={mine}
                          imgHref={`/video-page/${item?.video_post.id}`}
                          iconHref={`/video-page/${item?.video_post.id}`}
                          videoTitleHref={`/video-page/${item?.video_post.id}`}
                          videoId={item.video_post.id}
                          channelName={item?.video_post.channel.name}
                          channelId={item?.video_post.channel.id}
                        />
                      </Col>
                    ))
                  ) : (
                    <p className="mr-3">ویدئوای وجود ندارد.</p>
                  )
                ) : videos?.length > 0 || selectedTabVideos?.length > 0 ? (
                  campaignId ? (
                    Object.entries(groupedCampaignVideos).map(
                      ([campaignName, group]) => (
                        <div key={campaignName}>
                          <h5
                            className="mb-3 mt-4"
                            style={{ fontWeight: "bold", color: "#444" }}
                          >
                            {campaignName}
                          </h5>
                          <Row>
                            {group.map((item, index) => (
                              <Col xl={2} sm={4} className="mb-3" key={index}>
                                <VideoCard
                                  imgSrc={
                                    item?.cover
                                      ? baseURL + item?.cover
                                      : "img/v4.png"
                                  }
                                  time={item?.duration}
                                  videoTitle={item?.title}
                                  videoCategory={item?.categorys?.name}
                                  views={item?.counted_views}
                                  timeAgo={item?.published_date}
                                  verified
                                  mine={mine}
                                  admin={adminValue}
                                  imgHref={`/video-page/${item?.id}/?campaign=${item?.campaign?.id}&category=${item.categorys?.id}`}
                                  iconHref={`/video-page/${item?.id}/?campaign=${item?.campaign?.id}&category=${item.categorys?.id}`}
                                  videoTitleHref={`/video-page/${item.id}/?campaign=${item?.campaign?.id}&category=${item.categorys?.id}`}
                                  videoId={item.id}
                                  channelName={item?.campaign?.name}
                                  channelId={item?.campaign?.id}
                                  select={all}
                                  campaign={campaignId}
                                  videoRate={item?.video_rate}
                                  videoPublisher={
                                    item?.publisher?.first_name +
                                    " " +
                                    item?.publisher?.last_name
                                  }
                                />
                              </Col>
                            ))}
                          </Row>
                        </div>
                      )
                    )
                  ) : tab === "ویدئوهای منتخب" ? (
                    selectedTabVideos.map((item, index) => (
                      <Col xl={2} sm={4} className="mb-3" key={index}>
                        <VideoCard
                          imgSrc={item?.video?.cover}
                          time={item?.video?.duration}
                          videoTitle={item?.video?.title}
                          videoCategory={item?.video?.categorys?.name}
                          views={item?.video?.counted_views}
                          timeAgo={item?.video?.published_date}
                          verified
                          mine={mine}
                          admin={adminValue}
                          imgHref={`/video-page/${item?.video?.id}`}
                          iconHref={`/video-page/${item?.video?.id}`}
                          videoTitleHref={`/video-page/${item?.video?.id}`}
                          videoId={item?.video.id}
                          channelName={item?.video?.channel?.name}
                          channelId={item?.video?.channel?.id}
                          select={all}
                          campaign={campaignId}
                        />
                      </Col>
                    ))
                  ) : (
                    videos.map((item, index) => (
                      <Col xl={2} sm={4} className="mb-3" key={index}>
                        <VideoCard
                          imgSrc={item?.cover ? item?.cover : "img/v4.png"}
                          time={item?.duration}
                          videoTitle={item?.title}
                          videoCategory={item?.categorys?.name}
                          views={item?.counted_views}
                          timeAgo={item?.published_date}
                          verified
                          mine={mine}
                          admin={adminValue}
                          imgHref={`/video-page/${item?.id}`}
                          iconHref={`/video-page/${item?.id}`}
                          videoTitleHref={`/video-page/${item?.id}`}
                          videoId={item.id}
                          channelName={item?.channel?.name}
                          channelId={item?.channel?.id}
                          select={all}
                          campaign={campaignId}
                          repost={item?.is_repost}
                        />
                      </Col>
                    ))
                  )
                ) : (
                  <p className="mr-3" style={{ textAlign: "right" }}>
                    {categoryName && tagName
                      ? "ویدئوای برای دسته بندی و تگ منتخب شما وجود ندارد."
                      : "ویدئوای وجود ندارد."}
                  </p>
                )}
              </Row>
            </>
          )}

          {showPagination && (
            <Paginate
              count={totalCount}
              value={paginationInfo}
              onPageChange={handlePageChange}
              limit={12}
            />
          )}
        </div>
      </Container>
    </ContentWrapper>
  );
};

export default Videos;

// Local simple debounce hook to avoid new dependency
function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
